import React from 'react';
import { useParams } from 'react-router';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import { AdsAdminRoutes } from './ads_admin_routes';
import UniversalPromoCampaignFormContainer from '../components/promo_codes_admin/universal_promo_campaign_form_container';

// The container's graphql config reads props.params.campaignId (injected by
// the v3 router; its own conversion happens in the withRouter sweep).
function UniversalPromoCampaignFormPage() {
  const params = useParams();
  const routeProps = { params } as any;

  return <UniversalPromoCampaignFormContainer {...routeProps} />;
}

export const AdminRoutes = [
  ...AdsAdminRoutes,
  <Route
    key="/admin/universal_promo_campaigns/new"
    path="admin/universal_promo_campaigns/new"
    handle={{ clientSide: true }}
    Component={UniversalPromoCampaignFormPage}
  />,
  <Route
    key="/admin/universal_promo_campaigns/:campaignId/edit"
    path="admin/universal_promo_campaigns/:campaignId/edit"
    handle={{ clientSide: true }}
    Component={UniversalPromoCampaignFormPage}
  />,
];
